import { VideoStore } from '../video.store';
import {
  ControlsStrategyType,
  ControlsStrategyTypes,
  DefaultControlsStrategy
} from './default-controls-strategy';
import { ConfigStore } from '../config.store';

export class MpuControlsStrategy extends DefaultControlsStrategy {
  type: ControlsStrategyType = ControlsStrategyTypes.MPU;
  constructor(
    videoStore: VideoStore,
    config: ConfigStore,
    adContext: Record<string, any>
  ) {
    super(videoStore, config, adContext);
  }

  shouldDisplayOptOut(): boolean {
    return this.adContext.showOptoutLink;
  }

  shouldHideOptout(): boolean {
    return this.configStore.config.optOut.hide;
  }
}
